import React, { CSSProperties, PropsWithChildren } from 'react';
import styles from './Box.module.scss';

type BoxOwnProps = {
  className?: string;
  noMinWidth?: boolean;
  style?: CSSProperties;
};

type BoxProps = PropsWithChildren<BoxOwnProps>;
const Box: React.FC<BoxProps> = ({ className = '', noMinWidth = false, style = {}, children }) => {
  const minWidthCls = noMinWidth ? '' : styles.BoxWithMinWidth;
  const baseCls = `${styles.Box} ${className} ${minWidthCls}`;
  return (
    <div className={baseCls} style={style}>
      {children}
    </div>
  );
};

export default Box;
